<template>
  <div class="navigation">
    <div class="logo"><img src="../assets/logo.png" alt="AIRBUS"></div>
    <div class="lanange">{{ lanange }}</div>
    <user-profile v-bind:userData="userData"></user-profile>
  </div>
</template>

<script>
    /* eslint-disable */
    import UserProfile from '@/components/UserProfile'
    export default {
        name: 'navigation-component',
        props: [
            'userData'
        ],
        data () {
            return {
                lanange: 'English',
                username: 'wfc\'s user'
            }
        },
        components: {
            UserProfile
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navigation {
    z-index: 10;
    float: left;
    top: 0px;
    width: 100%;
    height: 52px;
    padding: 8px 8px 3px 8px;
    cursor: pointer;
    background: #12285f none repeat scroll 0 0;
    color: #fff;
    position: fixed;
    display:table;
}
.logo {
    float: left;
}
.lanange {
    margin: 18px 0px 0px 8px;
    float: left;
    font-weight: normal;
    font-size:16px;
}
.userinfo {
    margin: 6px 20px 0px 0px;
    float: right;
    font-weight: normal;
    font-size:24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue